import React, { useEffect, useMemo, useState } from 'react'
import { observer } from 'mobx-react'
import { AnalyticsScript } from '~/components/business/AnalyticsScript'
import classNames from 'classnames'
import { Header, HeaderType } from './header'
import { Footer } from './footer'
import { useStores } from '~/hooks/useStores'
import { LoginModal } from '~/components/pages/login/LoginModal'
import { RightBar } from '~/components/business/RightBar'
import { ResetPwdModal } from '~/components/pages/login/ResetPwdModal'
import { MyModal } from '~/components/ui/MyModal'
import { SetPwdModal } from '~/components/pages/settings/SetPwdModal'
import Cookies from 'js-cookie'
import { MyDivide } from '~/components/ui/MyDivide'
import { MyBtn } from '~/components/ui/MyBtn'

export const Layout: React.FC<{
  className?: string
  mainClassName?: string
  mainStyle?: React.CSSProperties
  children: React.ReactNode
  /** 默认黑色主题，否则白色主题 */
  dark?: boolean
  /** 显示header右侧模块 */
  headerType?: HeaderType
  headerShowRight?: boolean
  footerClassName?: string
  headerClassName?: string
  showFooter?: boolean
}> = observer(
  ({
    children,
    className,
    mainClassName,
    mainStyle,
    dark = true,
    headerType = 'normal',
    headerShowRight = true,
    footerClassName,
    headerClassName,
    showFooter = true,
  }) => {
    const { store } = useStores()

    const isProd = process.env.NEXT_PUBLIC_NODE_ENV === 'production'
    const loginVisible = !!store.modal?.login
    const resetPwdVisible = !!store.modal?.resetPwd
    const [showSafePassword, setShowSafePassword] = useState(false)
    const [passwordVisible, setPasswordVisible] = useState(false)

    useEffect(() => {
      window.oncontextmenu = function (e) {
        // 大佬需求，不让右键下载图片
        if ((e?.target as any)?.nodeName === 'IMG') {
          e.preventDefault()
        }
      }
      const safe = Cookies.get('safe')
      if (safe == '1') {
        setShowSafePassword(true)
        Cookies.remove('safe')
      }
    }, [])

    return (
      <div
        className={classNames(
          'min-h-screen min-w-[1400px]',
          dark ? '' : 'bg-neutral-900',
          className
        )}
      >
        <Header
          type={headerType}
          headerShowRight={headerShowRight}
          className={headerClassName}
          dark={dark}
        />
        <main
          className={classNames(mainClassName)}
          style={{
            minHeight:
              headerType === 'no-margin'
                ? 'calc(100vh - 56px - 242px)'
                : 'calc(100vh - 56px - 242px - 24px)',
            ...mainStyle,
          }}
        >
          {children}
        </main>
        {showFooter && <Footer className={footerClassName} dark={dark} />}
        {loginVisible && <LoginModal />}
        {resetPwdVisible && <ResetPwdModal />}
        <RightBar dark={dark} />
        {isProd && <AnalyticsScript />}
        {showSafePassword && (
          <MyModal
            dark={true}
            open={showSafePassword}
            title="安全提示"
            onCancel={() => setShowSafePassword(false)}
            maskStyle={{
              backgroundColor: 'rgba(0,0,0,0.8)',
            }}
            width={375}
            footer={null}
          >
            <div className="text-base text-neutral-400">
              您的账户安全等级较低，建议重新设置密码
            </div>
            <MyDivide space={32} dark={true} />
            <MyBtn
              type="primary"
              size="large"
              block
              onClick={() => {
                setShowSafePassword(false)
                setPasswordVisible(true)
              }}
            >
              确定
            </MyBtn>
          </MyModal>
        )}
        {passwordVisible && (
          <SetPwdModal
            visible={passwordVisible}
            setVisible={setPasswordVisible}
          />
        )}
      </div>
    )
  }
)
